import { Injectable } from '@nestjs/common';
import { IdTokenData } from '../models/id-token-data';
import { JwtService } from '@nestjs/jwt';
import { UserEntity } from '@ip6m/server/data-access-user';

@Injectable()
export class TokenService {
  constructor(private jwtService: JwtService) {}

  signIdToken(idTokenData: IdTokenData): string {
    return this.jwtService.sign({ ...idTokenData, type: 'ID_TOKEN' });
  }

  signAccessToken(sub: string): string {
    return this.jwtService.sign({ sub, type: 'ACCESS_TOKEN' });
  }

  verifyAccessToken(token: string): { sub: string; type: string } {
    return this.jwtService.verify(token);
  }

  idTokenFromUser(user: UserEntity) {
    return this.signIdToken({
      sub: user.id,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      phone: user.phone,
      roles: user.roles
    });
  }

  accessTokenFromUserId(id: UserEntity['id']) {
    return this.signAccessToken(id.toString());
  }
}
